import { auth, db } from '../lib/supabase.js'

export class AuthComponent {
  constructor(container, onAuthChange) {
    this.container = container
    this.onAuthChange = onAuthChange || (() => {})
    this.isSignUp = false
    
    this.render()
    this.attachEventListeners()
  }

render() {
  this.container.innerHTML = `
    <div class="auth-container">
    <div class="auth-scribble"></div>
      <div class="auth-form">
        <h2 style="color: ${document.body.classList.contains('dark-mode') ? 'var(--dark-text-primary)' : 'var(--accent-color)'};">${this.isSignUp ? 'Create Account' : 'Sign In'}</h2>
        
        <form id="authForm">
          <div class="form-group">
            <label for="email">Email</label>
            <input 
              type="email" 
              id="email" 
              name="email" 
              required 
              placeholder="Enter your email"
              autocomplete="email"
            >
          </div>
          
          <div class="form-group">
            <label for="password">Password</label>
            <input 
              type="password" 
              id="password" 
              name="password" 
              required 
              placeholder="Enter your password"
              autocomplete="${this.isSignUp ? 'new-password' : 'current-password'}"
              minlength="6"
            >
          </div>
          
          ${this.isSignUp ? `
            <div class="form-group">
              <label for="favoriteGenre">Favorite Music Genre (Optional)</label>
              <select id="favoriteGenre" name="favoriteGenre">
                <option value="daily">Daily Hits</option>
                <option value="rock">Rock</option>
                <option value="pop">Pop</option>
                <option value="hiphop">Hip-Hop</option>
                <option value="country">Country</option>
                <option value="rb">R&B/Soul</option>
                <option value="indie">Indie</option>
                <option value="classic">Classic Hits</option>
                <option value="classichiphop">Classic Hip-Hop</option>
              </select>
            </div>
          ` : ''}
          
          <button type="submit" class="btn btn-primary" style="width: 100%;">
            ${this.isSignUp ? 'Create Account' : 'Sign In'}
          </button>
        </form>
        
        <div class="auth-toggle">
          ${this.isSignUp ? 'Already have an account?' : "Don't have an account?"}
          <button type="button" id="toggleMode">
            ${this.isSignUp ? 'Sign In' : 'Sign Up'}
          </button>
        </div>
        
        <div class="auth-toggle" style="margin-top: 16px;">
          <button type="button" id="skipAuth" class="btn" style="width: 100%;">
            Continue as Guest
          </button>
        </div>
        
        <div id="authError" style="color: var(--error-color); margin-top: 16px; text-align: center; display: none; padding: 12px; background: #fee; border-radius: 6px;"></div>
        <div id="authSuccess" style="color: var(--accent-color); margin-top: 16px; text-align: center; display: none; padding: 12px; background: #efe; border-radius: 6px; border: 1px solid var(--accent-color);"></div>
      </div>
    </div>
  `
}

  attachEventListeners() {
    const form = this.container.querySelector('#authForm')
    const toggleButton = this.container.querySelector('#toggleMode')
    const skipButton = this.container.querySelector('#skipAuth')
    
    form.addEventListener('submit', (e) => this.handleSubmit(e))
    toggleButton.addEventListener('click', () => this.toggleMode())
    skipButton.addEventListener('click', () => this.skipAuth())
  }

async handleSubmit(e) {
  e.preventDefault()
  
  const formData = new FormData(e.target)
  const email = formData.get('email')
  const password = formData.get('password')
  const favoriteGenre = formData.get('favoriteGenre') || 'daily'
  
  this.clearMessages()
  this.setLoading(true)
  
  try {
    if (this.isSignUp) {
      await this.signUp(email, password, favoriteGenre)
    } else {
      await this.signIn(email, password)
    }
  } catch (error) {
    console.error('Auth error:', error)
    this.showError(error.message || 'An error occurred. Please try again.')
  } finally {
    this.setLoading(false)
  }
}

async signUp(email, password, favoriteGenre) {
  try {
    const { user, error } = await auth.signUp(email, password)
    
    if (error) throw error
    
    if (user) {
      this.showSuccess('Account created! Check your email (including spam folder) to confirm your account.')
      
      // Don't clear the form immediately - let user see the success message
      // Clear it after a delay
      setTimeout(() => {
        const form = this.container.querySelector('#authForm')
        if (form) form.reset()
      }, 2000)
      
      // Don't auto-sign in - wait for email verification
    } else {
      this.showError('Failed to create account. Please try again.')
    }
  } catch (error) {
    throw error // Let handleSubmit catch and display this
  }
}

  async signIn(email, password) {
    const { user } = await auth.signIn(email, password)
    
    if (user) {
    this.onAuthChange(user)
    } else {
      this.showError('Failed to sign in. Please check your credentials.')
    }
  }

  toggleMode() {
    this.isSignUp = !this.isSignUp
    this.clearMessages()
    this.render()
    this.attachEventListeners()
  }

  skipAuth() {
    this.onAuthChange(null)
  }

setLoading(loading) {
  const submitBtn = this.container.querySelector('button[type="submit"]')
  const form = this.container.querySelector('#authForm')
  
  if (submitBtn && form) {  // Add null checks
    if (loading) {
      submitBtn.disabled = true
      submitBtn.textContent = 'Loading...'
      form.style.opacity = '0.7'
    } else {
      submitBtn.disabled = false
      submitBtn.textContent = this.isSignUp ? 'Create Account' : 'Sign In'
      form.style.opacity = '1'
    }
  }
}

showError(message) {
  const errorDiv = this.container.querySelector('#authError')
  const successDiv = this.container.querySelector('#authSuccess')
  
  if (successDiv) successDiv.style.display = 'none'
  if (errorDiv) {
    errorDiv.textContent = message
    errorDiv.style.display = 'block'
  } else {
    // Fallback if elements don't exist
    alert('Error: ' + message)
  }
}

showSuccess(message) {
  const errorDiv = this.container.querySelector('#authError')
  const successDiv = this.container.querySelector('#authSuccess')
  
  if (errorDiv) errorDiv.style.display = 'none'
  if (successDiv) {
    successDiv.textContent = message
    successDiv.style.display = 'block'
  } else {
    // Fallback if elements don't exist
    alert('Success: ' + message)
  }
}

clearMessages() {
  const errorDiv = this.container.querySelector('#authError')
  const successDiv = this.container.querySelector('#authSuccess')
  
  if (errorDiv) errorDiv.style.display = 'none'
  if (successDiv) successDiv.style.display = 'none'
}

  destroy() {
    // Clean up event listeners if needed
    this.container.innerHTML = ''
  }
}